import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { num, showMoney } from "@/lib/format";

export const TIERS = {
  nessuna: { label: "Nessuna spesa", range: "0 €", cls: "border-border text-muted-foreground" },
  bronzo: { label: "Bronzo", range: "1 – 400 €", cls: "border-orange-700/50 text-orange-400" },
  argento: { label: "Argento", range: "401 – 900 €", cls: "border-slate-400/50 text-slate-300" },
  oro: { label: "Oro", range: "901 – 1700 €", cls: "border-yellow-500/50 text-yellow-400" },
  platino: { label: "Platino", range: "oltre 1700 € · o 5000 €+ in 12 mesi · o 10000 €+ totali", cls: "border-cyan-400/50 text-cyan-300" },
};

export const RECENCY = {
  attivo: { label: "Attivo", range: "ultimi 3 mesi", cls: "border-emerald-500/50 text-emerald-400" },
  ricontattare: { label: "Da ricontattare", range: "3 – 6 mesi", cls: "border-amber-500/50 text-amber-400" },
  rischio: { label: "A rischio", range: "6 – 12 mesi", cls: "border-orange-500/50 text-orange-400" },
  perso: { label: "Perso", range: "oltre 12 mesi", cls: "border-red-500/50 text-red-400" },
  nessuno: { label: "Mai acquistato", range: "nessun ordine", cls: "border-border text-muted-foreground" },
};

export const SegmentBadge = ({ map, value, testid }) => map[value] ? (
  <Badge variant="outline" className={`text-[10px] ${map[value].cls}`} data-testid={testid}>{map[value].label}</Badge>
) : null;

const Group = ({ title, map, counts, active, onPick, prefix }) => (
  <Card className="p-5">
    <p className="mb-3 font-mono-erp text-[11px] uppercase tracking-widest text-muted-foreground">{title}</p>
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5">
      {Object.entries(map).map(([k, v]) => (
        <button key={k} onClick={() => onPick(active === k ? null : k)} data-testid={`${prefix}-${k}`}
          className={`rounded-md border p-3 text-left transition-colors hover:bg-secondary/50 ${active === k ? "border-primary bg-secondary/60" : "border-border/60"}`}>
          <p className={`text-xs font-semibold ${v.cls.split(" ").pop()}`}>{v.label}</p>
          <p className="font-display text-xl font-bold" data-testid={`${prefix}-${k}-count`}>{num(counts[k] || 0)}</p>
          {(showMoney() || !v.range.includes("€")) && <p className="text-[11px] text-muted-foreground">{v.range}</p>}
        </button>
      ))}
    </div>
  </Card>
);

export const SeasonFilter = ({ season, value, onChange }) => (
  <div className="mb-4 flex flex-wrap items-center gap-2" data-testid="season-filter">
    <span className="font-mono-erp text-[11px] uppercase tracking-widest text-muted-foreground">Stagione {season}</span>
    {[["tutti", "Tutti"], ["comprato", `Ha comprato ${season}`], ["non_comprato", `Non ha ancora comprato ${season}`]].map(([k, l]) => (
      <button key={k} onClick={() => onChange(k)} data-testid={`season-filter-${k}`}
        className={`rounded-full border px-3 py-1 text-xs transition-colors ${value === k ? "border-primary bg-primary text-primary-foreground" : "border-border/60 hover:bg-secondary/50"}`}>{l}</button>
    ))}
  </div>
);

export const NewSeasonFilter = ({ season, value, onChange }) => (
  <div className="-mt-2 mb-4 flex flex-wrap items-center gap-2" data-testid="new-season-filter">
    <span className="font-mono-erp text-[11px] uppercase tracking-widest text-muted-foreground">Nuovi clienti {season}</span>
    {[["tutti", "Tutti"], ["senza_secondo", "Nessun secondo ordine"], ["con_secondo", "Con secondo ordine"]].map(([k, l]) => (
      <button key={k} onClick={() => onChange(k)} data-testid={`new-season-filter-${k}`}
        className={`rounded-full border px-3 py-1 text-xs transition-colors ${value === k ? "border-primary bg-primary text-primary-foreground" : "border-border/60 hover:bg-secondary/50"}`}>{l}</button>
    ))}
  </div>
);

export const CustomerSegments = ({ matrix, season, tier, recency, onTier, onRecency }) => {
  const tierCounts = Object.fromEntries(Object.keys(TIERS).map((t) => [t,
    Object.entries(matrix[t] || {}).reduce((s, [r, n]) => s + (!recency || r === recency ? n : 0), 0)]));
  const recCounts = Object.fromEntries(Object.keys(RECENCY).map((r) => [r,
    Object.entries(matrix).reduce((s, [t, row]) => s + (!tier || t === tier ? row[r] || 0 : 0), 0)]));
  return (
    <div className="mb-6 grid grid-cols-1 gap-4 xl:grid-cols-2" data-testid="customer-segments">
      <Group title={`Fasce di spesa · collezione ${season}`} map={TIERS} counts={tierCounts} active={tier} onPick={onTier} prefix="tier" />
      <Group title="Ultimo acquisto · chi ricontattare" map={RECENCY} counts={recCounts} active={recency} onPick={onRecency} prefix="recency" />
    </div>
  );
};
